<div class="dialogbox">
  <ng-container [ngTemplateOutlet]="data.template"></ng-container>
</div>
